import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form, FormGroup, Label } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import TextInput from '../../../common/forms/input/TextInput';
import { isRequired } from '../../../../utils/validators';
import FormItem from '../../../common/forms/FormItem';
import Loader from '../../../common/Loader';
import FormFooter from '../../../common/forms/FormFooter';
import {
  clearOrganizationCharts,
  getOrganizationCharts,
} from '../../../../actions';
import DynamicForm from '../../../common/forms/DynamicForm';
import Select from '../../../common/forms/select/Select';
import {
  CONTRACT_TYPE,
  DISCOUNT_CODE_TYPE,
  DISCOUNT_PRODUCT_TYPE,
} from '../../../../config/constants';
import { enumToSelectOptions } from '../../../../utils/enum';
import {
  DISCOUNT_CODE_EXCLUDE_DATES_COLUMNS,
  DISCOUNT_CODE_TRIP_RULE_COLUMNS,
} from '../../../../config/dynamicFormFields';
import ServiceTypeSelect from '../../../common/forms/select/ServiceTypeSelect';
import DatePicker from '../../../common/forms/input/DatePicker';
import RouteSelect from '../../../common/forms/select/RouteSelect';
import AgencySelect from '../../../common/forms/select/AgencySelect';
import UserSelect from '../../../common/forms/select/UserSelect';
import SecurityProfileSelect from '../../../common/forms/select/SecurityProfileSelect';
import CustomerSelect from '../../../common/forms/select/CustomerSelect';
import DiscountCodeCategorySelect from '../../../common/forms/select/DiscountCodeCategorySelect';

export const DiscountCodeForm = ({ handleSubmit, loading }) => {
  if (loading) return <Loader />;

  return (
    <Form onSubmit={handleSubmit}>
      <FormGroup row>
        <FormItem label="Nombre" required>
          <Field
            name="name"
            component={TextInput}
            type="text"
            placeholder="Nombre"
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Descripción" required>
          <Field
            name="description"
            component={TextInput}
            type="text"
            placeholder="Descripción"
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Código" required>
          <Field
            name="code"
            component={TextInput}
            type="text"
            placeholder="Código"
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Tipo de Descuento" required>
          <Field
            name="discountType"
            id="discountType"
            component={Select}
            options={enumToSelectOptions(DISCOUNT_CODE_TYPE)}
            showToolTip
            placeholder="Tipo de Descuento"
            isClearable={false}
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Descuento" required>
          <Field
            name="discount"
            component={TextInput}
            type="text"
            placeholder="Descuento"
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Monto Máximo">
          <Field
            name="maxAmount"
            component={TextInput}
            type="text"
            placeholder="Monto Máximo"
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Máximo número de usos">
          <Field
            name="maxNumberOfUses"
            component={TextInput}
            type="text"
            placeholder="Máximo número de usos"
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Tipo de Servicio">
          <Field
            name="serviceType"
            component={ServiceTypeSelect}
            placeholder="Tipo de Servicio"
            isClearable
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Tipo de Producto">
          <Field
            name="productType"
            component={Select}
            options={enumToSelectOptions(DISCOUNT_PRODUCT_TYPE)}
            placeholder="Tipo de Producto"
            isClearable
          />
        </FormItem>
      </FormGroup>
      <h3>Servicios</h3>
      <DynamicForm
        name="discountCodeTripRuleList"
        columns={DISCOUNT_CODE_TRIP_RULE_COLUMNS}
      />
      <FormGroup row>
        <FormItem>
          <Label>
            <Field
              name="isValid"
              id="isValid"
              component="input"
              type="checkbox"
            />{' '}
            Valido{' '}
          </Label>
        </FormItem>
      </FormGroup>

      <FormGroup row>
        <FormItem label="Usuario Autorizador" required>
          <Field
            name="authorizerUserId"
            component={UserSelect}
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>

      <FormGroup row>
        <FormItem label="Categoría de Descuento">
          <Field
            name="discountCodeCategoryId"
            component={DiscountCodeCategorySelect}
            isClearable
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem>
          <Label>
            <Field
              name="applyOnlyAfterDeparture"
              id="applyOnlyAfterDeparture"
              component="input"
              type="checkbox"
            />{' '}
            Aplica Solo Después de la Salida del Viaje
          </Label>
        </FormItem>
      </FormGroup>
      <h3>Fechas</h3>
      <FormGroup row>
        <FormItem label="Válido Desde">
          <Field
            name="validFrom"
            component={DatePicker}
            placeholder="Válido Desde"
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Válido Hasta">
          <Field
            name="validUntil"
            component={DatePicker}
            placeholder="Válido Hasta"
          />
        </FormItem>
      </FormGroup>
      <h3>Fechas Excluidas</h3>
      <DynamicForm
        name="excludedDateRangeSet"
        columns={DISCOUNT_CODE_EXCLUDE_DATES_COLUMNS}
      />
      <FormGroup row>
        <FormItem label="Rutas Incluidas: ">
          <Field name="includedRouteSet" component={RouteSelect} isMulti />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Rutas Excluidas: ">
          <Field name="excludedRouteSet" component={RouteSelect} isMulti />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Agencias Incluidas: ">
          <Field name="includeAgencySet" component={AgencySelect} isMulti />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Usuarios Incluidos: ">
          <Field name="includeUserSet" component={UserSelect} isMulti />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Clientes Incluidos: ">
          <Field name="customerSet" component={CustomerSelect} isMulti />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Perfiles de Seguridad Incluidos: ">
          <Field
            name="includeSecurityProfileSet"
            component={SecurityProfileSelect}
            isMulti
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Tipos de Contrato">
          <Field
            name="agencyContractTypeDiscountCodeSet"
            component={Select}
            isMulti
            options={enumToSelectOptions(CONTRACT_TYPE)}
          />
        </FormItem>
      </FormGroup>
      <FormFooter />
    </Form>
  );
};

DiscountCodeForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

DiscountCodeForm.defaultProps = {
  loading: false,
};

const mapStateToProps = (state) => ({
  loading: !state.SalesUnit.DiscountCode.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

const mapDispatchToProps = {
  dispatchGetOrganizationCharts: getOrganizationCharts,
  dispatchClearOrganizationCharts: clearOrganizationCharts,
};

const formComponent = reduxForm({
  form: 'DiscountCodeForm',
})(DiscountCodeForm);

export default connect(mapStateToProps, mapDispatchToProps)(formComponent);
